<!--  -->

<template>
  <div class="firm-body">
    <!-- 面包屑  -->

    <p class="title-Individual-center">
      <span>招聘管理</span>

      <i class="el-icon-arrow-right"></i>

      <span class="span-Individual-center">{{ routeName }}</span>
    </p>

    <!-- 主体 -->

    <div class="EliteRecommendation">
      <div class="box-top flex-box">
        <div class="left-box">
          <div class="top-left">
            <div class="text1">工作经验：</div>

            <div
              :class="item.id == experienceIndex ? 'text2-active' : 'text2'"
              v-for="(item, index) in workExpEnumList"
              :key="index"
              @click="experienceChange(item)"
            >
              {{ item.name }}
            </div>
          </div>

          <div class="top-left">
            <div class="text1">学历要求：</div>

            <div
              :class="item.id == qualificationIndex ? 'text2-active' : 'text2'"
              v-for="(item, index) in xlList"
              :key="index"
              @click="qualificationChange(item)"
            >
              {{ item.name }}
            </div>
          </div>

          <div class="top-left">
            <div class="text1">薪资待遇：</div>

            <div
              :class="index == salaryIndex ? 'text2-active' : 'text2'"
              v-for="(item, index) in salaryList"
              :key="index"
              @click="salaryChange(item, index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>

        <div class="top-right">
          <span>职业类型：</span>

          <el-select
            placeholder="请选择职业类型"
            style="width: 200px; margin-left: 20px"
            clearable
            @change="optionsChange"
            v-model="positionCode"
            filterable
            remote
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="
                item.positionName + '-' + item.cityName + '-' + item.salaryRange
              "
              :value="
                item.dictPositionCode3 +
                '-' +
                item.cityCode +
                '-' +
                item.salaryMin +
                '-' +
                item.salaryMax
              "
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="box-bottom">
        <el-collapse accordion>
          <el-collapse-item v-for="(item, index) in list" :key="index">
            <template slot="title">
              <div class="title firm-clickable" @click="viewEliteResume(item)">
                <div class="left flex-box2">
                  <div class="left-img">
                    <div class="left-img-Mask" v-if="item.hide == true"></div>

                    <img :src="item.userImg" alt="" />

                    <!-- <img src="../../../../assets/imgs/img/fankui.png" alt="" /> -->
                  </div>

                  <div class="left-text">
                    <div>
                      <span
                        style="font-size: 16px; color: #333; font-weight: 500"
                        >{{ item.username }}</span
                      >

                      <span>{{ item.sex == 1 ? "男" : "女" }}</span>

                      <span>{{ item.age }}岁</span>

                      <span>{{ item.xlName }}</span>

                      <span>{{ item.workExpYear }}年</span>

                      <span>{{ item.jobStatusName }}</span>
                    </div>

                    <div>
                      <span>{{
                        item.userJobIntentionList[0].addressName
                      }}</span>

                      <span>{{
                        item.userJobIntentionList[0].positionName
                      }}</span>

                      <span>{{
                        item.userJobIntentionList[0].hopeMinSalary === 0 &&
                        item.userJobIntentionList[0].hopeMaxSalary === 0
                          ? "面议"
                          : item.userJobIntentionList[0].hopeMinSalary / 1000 +
                            "k-" +
                            item.userJobIntentionList[0].hopeMaxSalary / 1000 +
                            "k"
                      }}</span>

                      <span
                        :title="item.userJobIntentionList[0].industryTypeName"
                        >{{
                          item.userJobIntentionList[0].industryTypeName
                        }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="center">
                  <img
                    src="@/assets/imgs/shoucang@3x.svg"
                    alt=""
                    v-if="item.collectOrNot"
                    @click.stop="collectElite(item)"
                  />
                  <img
                    src="@/assets/imgs/shoucang-null@3x.svg"
                    alt=""
                    v-else
                    @click.stop="collectElite(item)"
                  />

                  <!-- 索要联系方式：微信 / 手机（逻辑与精英管理一致） -->

                  <img
                    src="@/assets/imgs/weixin@3x.svg"
                    alt=""
                    style="margin-left: 10px; cursor: pointer"
                    v-if="item.eliteWechat"
                    @click.stop="showContactTip(item, true)"
                  />

                  <el-popover
                    v-else
                    placement="top"
                    width="180"
                    trigger="hover"
                    popper-class="elite-contact-popover"
                  >
                    <div class="contact-popover-content">
                      <div class="contact-popover-text">
                        确认索要对方微信号？
                      </div>

                      <el-button
                        type="text"
                        size="mini"
                        class="contact-popover-btn"
                        @click.stop="onClickContactApply(item, true)"
                      >
                        确认
                      </el-button>
                    </div>

                    <img
                      slot="reference"
                      src="@/assets/imgs/weixin-weijiaohuan@3x.svg"
                      alt=""
                      style="margin-left: 10px; cursor: pointer"
                    />
                  </el-popover>

                  <img
                    src="@/assets/imgs/dianhua@3x.svg"
                    alt=""
                    style="margin-left: 10px; cursor: pointer"
                    v-if="item.elitePhone"
                    @click.stop="showContactTip(item, false)"
                  />

                  <el-popover
                    v-else
                    placement="top"
                    width="180"
                    trigger="hover"
                    popper-class="elite-contact-popover"
                  >
                    <div class="contact-popover-content">
                      <div class="contact-popover-text">
                        确认索要对方手机号？
                      </div>

                      <el-button
                        type="text"
                        size="mini"
                        class="contact-popover-btn"
                        @click.stop="onClickContactApply(item, false)"
                        style="width: 50px; text-align: center"
                      >
                        确认
                      </el-button>
                    </div>

                    <img
                      slot="reference"
                      src="@/assets/imgs/dianhua-weijiaohuan@3x.svg"
                      alt=""
                      style="margin-left: 10px; cursor: pointer"
                    />
                  </el-popover>
                </div>

                <div class="right">
                  <div
                    class="right-button firm-clickable"
                    @click.stop="goPj(item)"
                    v-if="item.hasEvaluation"
                  >
                    <img src="@/assets/imgs/fankui@3x.svg" alt="" />

                    <span style="margin-left: 4px">信用评价</span>
                  </div>

                  <div
                    class="right-button firm-clickable"
                    @click.stop="addInappropriateElite(item)"
                  >
                    <span>不合适</span>
                  </div>
                </div>
              </div>
            </template>

            <div class="text-content">
              <div class="right-top" v-if="!showNoResume" @click="onJb(item)">
                <img
                  src="@/assets/imgs/jinggao-L@3x.svg"
                  alt=""
                  style="color: #fff"
                />

                <span>举报</span>
              </div>

              <template v-if="showNoResume">
                <div class="no-resume-box">
                  <img
                    src="@/assets/imgs/no-jianli.png"
                    alt=""
                    class="work-icon"
                  />

                  <div class="no-resume-text">暂无简历</div>
                </div>
              </template>

              <template v-else>
                <div class="box-content" v-if="hasSelfEval">
                  <div class="title">自我评价：</div>

                  <div class="min-size">{{ detail.selfEval }}</div>
                </div>

                <div class="box-content" v-if="hasUserWorkExpList">
                  <p class="title">工作经历：</p>

                  <div
                    v-for="(item, index) in detail.userWorkExpList"
                    :key="index"
                  >
                    <div class="flex-box2">
                      <span style="margin-right: 40px; font-size: 16px">{{
                        item.companyName
                      }}</span>

                      <span>{{ item.startTime }} - {{ item.endTime }}</span>
                    </div>

                    <div class="flex-box2">
                      <span class="min-size" style="margin-right: 30px">{{
                        item.industryTypeName
                      }}</span>

                      <span class="min-size" style="margin-right: 30px">{{
                        item.positionName
                      }}</span>

                      <span class="min-size" style="margin-right: 30px"
                        >{{ item.monthlyPay }}/月</span
                      >
                    </div>

                    <div class="flex-box2">
                      <span>技能：</span>

                      <div
                        class="jn-item"
                        v-for="(items, indexs) in item.skillNameList"
                        :key="indexs"
                      >
                        {{ items }}
                      </div>
                    </div>

                    <div>
                      <div>工作描述：</div>

                      <div style="color: #666; margin: 10px 0">内容:</div>

                      <div v-html="item.jobEsc" class="min-size"></div>
                    </div>
                  </div>
                </div>
              </template>

              <div class="box-content" v-if="!showNoResume">
                <div class="title">项目经历：</div>

                <div
                  v-for="(item, index) in detail.userProjectExpList"
                  :key="index"
                >
                  <span class="min-size" style="margin-right: 20px">
                    {{ item.projectName }}
                  </span>

                  <span class="min-size" style="margin-right: 20px">
                    {{ item.positionName }}
                  </span>

                  <span class="min-size">
                    {{ item.startTime }} ~ {{ item.endTime }}</span
                  >

                  <div class="min-size">内容：</div>

                  <span class="min-size"> {{ item.projectContent }}</span>
                </div>
              </div>

              <div class="box-content" v-if="!showNoResume">
                <p class="title">教育经历：</p>

                <div
                  class="flex-box2"
                  v-for="(items, indexs) in detail.userEducationExpList"
                  :key="indexs"
                >
                  <span style="margin-right: 30px; font-size: 16px">{{
                    items.schoolName
                  }}</span>

                  <span style="margin-right: 30px; font-size: 16px">{{
                    items.xlName
                  }}</span>

                  <span style="margin-right: 30px; font-size: 16px">{{
                    items.subjectName
                  }}</span>

                  <span style="margin-right: 30px; font-size: 16px"
                    >{{ items.startTime }} - {{ items.endTime }}</span
                  >
                </div>
              </div>

              <div class="box-content" v-if="!showNoResume">
                <div class="title">证书：</div>

                <div
                  v-for="(item, index) in detail.userCertificateList"
                  :key="index"
                >
                  <span style="margin-right: 20px"> {{ item.name }} </span>

                  <span style="margin-right: 20px"> {{ item.code }} </span>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <dialogModel
      :visible.sync="dialogVisible"
      title="举报内容"
      @handleOk="handleOk"
    >
      <div style="padding: 20px; margin-left: 30px">
        <el-form
          :model="ruleForm"
          label-suffix="："
          label-position="top"
          :rules="rules"
          ref="ruleForm"
          label-width="1000px"
          class="demo-ruleForm"
        >
          <el-form-item label="举报内容" prop="textarea">
            <el-input
              :autosize="{ minRows: 4, maxRows: 10 }"
              type="textarea"
              placeholder="请输入至少10个字的举报内容"
              v-model="ruleForm.textarea"
              resize="none"
              maxlength="300"
              show-word-limit
              style="width: 600px"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="上传资料" prop="date">
            <zipUpload :key="uploadKey"></zipUpload>
          </el-form-item>
        </el-form>
      </div>
    </dialogModel>

    <!-- 底部分页 -->

    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>

    <Instruction
      :EliteCard="EliteCard"
      :Credit="Credit"
      :Instruction="Instruction"
      :dialogInstruction="dialogInstruction"
      @handleCloseInstruction="dialogInstruction = false"
      @handleInstruction="handleInstruction"
    ></Instruction>
  </div>
</template>



<script>
// 引入分页组件

import paging from "../../../../components/paging.vue";

import * as API from "@/assets/api/firm/firmRecruit.js";

import { workExpEnumList, xlList, salaryList } from "@/assets/js/common.js";

import zipUpload from "@/components/zipUpload.vue";

import {
  getPropCount, //获取道具剩余可用数量 Copy
  judgeCanCommunicateElite, //判断用不用消耗精英卡
  judgeCanFreeViewCreditEvaluation, //判断用不用消耗人才信用卡
  getPublishPositionInfoList, //获取当前招聘者已发布职位信息
} from "../../../../assets/api/firm/Opportunity";

import Instruction from "../components/Instruction.vue";

export default {
  components: { paging, zipUpload, Instruction },

  data() {
    return {
      //分页数据

      pagingObj: {
        currentPage: 1, //当前页

        pageSize: 12, // 一页显示多少个

        totalDevice: 0, //总数
      },

      //工作经验

      workExpEnumList,

      //学历要求

      xlList,

      //薪资待遇

      salaryList,

      routeName: "",

      // 精英推荐列表

      list: [],

      // 精英简历详情

      detail: "",

      // 工作经验索引

      experienceIndex: -1,

      // 学历索引

      qualificationIndex: -1,

      // 薪资待遇索引

      salaryIndex: 0,

      // 最小薪资

      hopeMinSalary: "",

      // 最大薪资

      hopeMaxSalary: "",

      /** 选了职业类型后先不传薪资；用户再改「薪资待遇」后置 false，恢复传 hopeMin/Max */

      omitSalaryWithPosition: false,

      // 地址code

      addressCode: "",

      // 职位code

      positionCode1: "",

      // 已选职业类型对应的职位 id

      positionId: "",

      // 已发布职业类型

      options: [],

      // 职位编码二类编码

      positionCode: "",

      dialogVisible: false,

      ruleForm: {
        textarea: "",
      },

      // 用于强制重置上传组件状态

      uploadKey: 1,

      rules: {
        textarea: [
          { required: true, message: "请输入举报内容", trigger: "blur" },

          { min: 10, max: 300, message: "请最少输入10个字", trigger: "blur" },
        ],
      },

      rowObj: "",

      EliteCard: 0, //精英卡剩余数量

      Credit: 0, //人才信用卡剩余数量

      Instruction: 0, // 0精英  1信用

      dialogInstruction: false,

      itemUserId: "", //点击沟通/信用评价存被点击项的userid

      // 联系方式申请（精英卡弹窗确认后回调）

      contactApplyPending: null,

      listArr: [],

      loading: false, // 添加屏蔽公司加载状态

      states: [], // 添加屏蔽公司 公司数据列表
    };
  },

  created() {
    this.routeName = this.$route.name;

    // this.recommendEliteByConditions();

    this.getPublishPositionCodes();

    // 获取道具剩余可用数量

    this.getPropCountElite();

    this.getPropCountCredit();
  },

  computed: {
    /**

     * 判断简历是否为空：

     * - selfEval 无值

     * - userWorkExpList 为空数组/无

     * 两者都为空则展示“暂无简历”

     */

    hasSelfEval() {
      const v = this.detail && this.detail.selfEval;

      return v != null && String(v).trim() !== "";
    },

    hasUserWorkExpList() {
      const list = this.detail && this.detail.userWorkExpList;

      return Array.isArray(list) && list.length > 0;
    },

    showNoResume() {
      return !this.hasSelfEval && !this.hasUserWorkExpList;
    },
  },

  methods: {
    // 联系方式状态时间（用于判断 7 天后才能重新申请）

    getContactStatusTime(row, isWx) {
      return isWx ? row.eliteWechatStatusTime : row.elitePhoneStatusTime;
    },

    // 是否已过 7 天（未过则不允许再次申请）

    canReapplyContactByTime(row, isWx) {
      const raw = this.getContactStatusTime(row, isWx);

      if (!raw) return { ok: true };

      const t = new Date(raw);

      const ms = t.getTime();

      if (Number.isNaN(ms)) return { ok: true };

      const limitMs = ms + 7 * 24 * 60 * 60 * 1000;

      if (Date.now() >= limitMs) return { ok: true };

      return { ok: false, retryAt: new Date(limitMs) };
    },

    // 已交换：提示用户已获取联系方式（此页不做复制弹窗）

    showContactTip(row, isWx) {
      if (!this.$checkAction()) return;

      const label = isWx ? "微信号" : "手机号";

      this.$tool.PromptBox("success", `已获取对方${label}，可在“精英管理”查看`);
    },

    // 未交换：按规则申请联系方式

    onClickContactApply(row, isWx) {
      if (!this.$checkAction()) return;

      const can = this.canReapplyContactByTime(row, isWx);

      if (!can.ok) {
        const dt = can.retryAt;

        const mm = String(dt.getMonth() + 1).padStart(2, "0");

        const dd = String(dt.getDate()).padStart(2, "0");

        const hh = String(dt.getHours()).padStart(2, "0");

        const mi = String(dt.getMinutes()).padStart(2, "0");

        this.$tool.PromptBox(
          "warning",

          `7天内不可重复申请，请于${mm}-${dd} ${hh}:${mi}后再试`
        );

        return;
      }

      const eliteId = row.userId;

      if (!eliteId) {
        this.$tool.PromptBox("warning", "无法识别精英信息");

        return;
      }

      const label = isWx ? "微信号" : "手机号";

      const applyContactType = isWx ? 1 : 0; // 1微信 0电话

      judgeCanCommunicateElite({ data: { userId: eliteId } }).then((res) => {
        if (res.code !== 0) return;

        const needConsumeCard = res.data === false;

        if (!needConsumeCard) {
          // 不再二次弹框：Popover 点击“确认”即直接索要

          API.contactApply({
            data: {
              eliteId,

              contactType: applyContactType,
            },
          }).then((applyRes) => {
            if (applyRes.code === 0) {
              this.$tool.PromptBox("success", "申请成功");

              this.recommendEliteByConditions();

              this.getPropCountElite();
            } else {
              this.$tool.PromptBox(
                "warning",

                applyRes.msg || applyRes.message || `申请${label}失败`
              );
            }
          });

          return;
        }

        // 需要消耗精英卡：不足则跳转购买；足够则打开 Instruction

        if (this.EliteCard > 0) {
          this.Instruction = 0;

          this.contactApplyPending = {
            eliteId,

            contactType: applyContactType,
          };

          this.dialogInstruction = true;

          return;
        }

        this.$confirmWithScroll("已无可用精英卡，是否前往购买？", "提示", {
          confirmButtonText: "确定",

          cancelButtonText: "取消",

          type: "warning",
        })

          .then(() => {
            this.$router.push("/Firm/propHire");
          })

          .catch(() => {});
      });
    },

    // 获取道具剩余可用数量

    getPropCountElite() {
      getPropCount({ data: 1 })
        .then((res) => {
          if (res && res.data) {
            this.EliteCard = res.data.propCount;
          }
        })

        .catch((err) => {
          console.error("获取道具数量失败：", err);
        });
    },

    // 获取道具剩余可用数量

    getPropCountCredit() {
      getPropCount({ data: 2 })
        .then((res) => {
          if (res && res.data) {
            this.Credit = res.data.propCount;
          }
        })

        .catch((err) => {
          console.error("获取道具数量失败：", err);
        });
    },

    // 前往信用评价：接口本身会返回“暂无评价/无可用信用卡”等业务提示，这里只做卡权限判断

    goPj(item) {
      this.Instruction = 1;

      this.itemUserId = item.userId;

      const judgeData = {
        data: {
          userId: item.userId,
        },
      };

      const lookData = {
        data: {
          userId: item.userId,

          positionId: this.positionId,
        },
      };

      judgeCanFreeViewCreditEvaluation(judgeData).then((res) => {
        if (res.code !== 0) {
          return;
        }

        if (res.data == false) {
          if (this.Credit > 0) {
            this.dialogInstruction = true;
          } else {
            this.$confirmWithScroll("已无可用人才信用卡，是否前往购买信息卡？", "提示", {
              confirmButtonText: "确定",

              cancelButtonText: "取消",

              type: "warning",
            })

              .then(() => {
                this.$router.push("/Firm/propHire");
              })

              .catch(() => {});
          }
        } else {
          // 业务接口会自己校验“是否有评价 / 是否还有可用信用卡”，这里只负责把后端提示展示出来

          API.lookUserCreditEvaluationByUserId(lookData).then((lookRes) => {
            if (lookRes.code !== 0) {
              this.$tool.PromptBox(
                "warning",

                lookRes.data ||
                  lookRes.msg ||
                  lookRes.message ||
                  "查看信用评价失败"
              );

              return;
            }

            this.$router.push({
              path: "/Firm/recruitElite/evaluate",

              query: { res: JSON.stringify(lookRes) },
            });
          });
        }
      });
    },

    // 确认支付道具卡查看/沟通

    handleInstruction() {
      if (this.Instruction == 0) {
        // 联系方式申请（精英卡确认后执行）

        if (this.contactApplyPending) {
          const { eliteId, contactType } = this.contactApplyPending;

          this.contactApplyPending = null;

          API.contactApply({
            data: {
              eliteId,

              contactType: Number(contactType),
            },
          }).then((applyRes) => {
            if (applyRes.code === 0) {
              this.$tool.PromptBox("success", "申请成功");

              this.recommendEliteByConditions();

              this.getPropCountElite();
            } else {
              this.$tool.PromptBox(
                "warning",

                applyRes.msg || applyRes.message || "申请失败"
              );
            }
          });
        }

        this.dialogInstruction = false;
      } else {
        //信用评价

        let data = {
          data: {
            userId: this.itemUserId,

            positionId: this.positionId,
          },
        };

        API.lookUserCreditEvaluationByUserId(data).then((res) => {
          if (res.code !== 0) {
            this.$tool.PromptBox(
              "warning",

              res.data || res.msg || res.message || "查看信用评价失败"
            );

            return;
          }

          this.$router.push({
            path: "/Firm/recruitElite/evaluate",

            query: { res: JSON.stringify(res) },
          });
        });

        this.dialogInstruction = false;
      }
    },

    // 工作经验切换

    experienceChange(item) {
      this.experienceIndex = item.id;

      this.recommendEliteByConditions();
    },

    // 学历要求切换

    qualificationChange(item) {
      this.qualificationIndex = item.id;

      this.recommendEliteByConditions();
    },

    // 薪资待遇切换

    salaryChange(item, index) {
      this.salaryIndex = index;

      this.hopeMinSalary = item.hopeMinSalary;

      this.hopeMaxSalary = item.hopeMaxSalary;

      this.omitSalaryWithPosition = false;

      this.recommendEliteByConditions(1);
    },

    // 职业类型筛选（清空后恢复为仅按左侧「薪资待遇」等条件搜索）

    optionsChange(val) {
      if (val == null || val === "") {
        this.positionCode = "";

        this.positionCode1 = "";

        this.positionId = "";

        this.addressCode = "";

        const sal = this.salaryList[this.salaryIndex];

        if (sal) {
          this.hopeMinSalary = sal.hopeMinSalary;

          this.hopeMaxSalary = sal.hopeMaxSalary;
        } else {
          this.hopeMinSalary = "";

          this.hopeMaxSalary = "";
        }

        this.omitSalaryWithPosition = false;

        this.recommendEliteByConditions();

        return;
      }

      this.positionCode = val;

      const result = String(val).split("-");

      this.positionCode1 = result[0];

      this.addressCode = result[1];

      const selected = this.options.find(
        (item) =>
          item.dictPositionCode3 +
            "-" +
            item.cityCode +
            "-" +
            item.salaryMin +
            "-" +
            item.salaryMax ===
          val
      );

      this.positionId = selected
        ? selected.positionId || selected.id || ""
        : "";

      // 选中职业类型：本次不传薪资；用户再改薪资待遇后会清除该标记并照常传参

      this.hopeMinSalary = "";

      this.hopeMaxSalary = "";

      this.omitSalaryWithPosition = true;

      this.recommendEliteByConditions();
    },

    // 获取企业已发布的二类职位编码列表

    getPublishPositionCodes() {
      var data = {
        data: {
          positionName: "",
        },
      };

      getPublishPositionInfoList(data).then((res) => {
        this.options = res.data;

        // 默认不按「职业类型」筛选：只拉取下拉数据，不自动选中第一条已发布职位

        this.positionCode = "";

        this.positionCode1 = "";

        this.positionId = "";

        this.addressCode = "";

        this.recommendEliteByConditions();
      });

      // let data1 = {

      //   data: {

      //     companyId: this.$store.getters.getCompany.id,

      //     publishUserId: this.$store.getters.getUser.id,

      //   },

      // };

      // API.getPublishPositionCodes(data1).then((res) => {

      //   this.options = res.data;

      // });
    },

    // 远程搜索

    async remoteMethod(query) {
      // 远程搜索前调用接口，传入搜索的数据获取企业名称放入this.states

      var data = {};

      data.data = {
        positionName: query,
      };

      if (query != "") {
        // 调用 获取企业名称接口

        await getPublishPositionInfoList(data, 1, 10).then((res) => {
          this.options = res.data;
        });
      }
    },

    // 获取精英推荐列表

    recommendEliteByConditions() {
      const query = {
        workExpEnum: this.experienceIndex,

        xl: this.qualificationIndex,

        addressCode: this.addressCode,

        positionCode: this.positionCode1,
      };

      // 无职业类型：始终带薪资；有职业类型且刚切换过职业类型：不传薪资，直到用户再改薪资待遇

      if (!this.positionCode1 || !this.omitSalaryWithPosition) {
        query.hopeMinSalary = this.hopeMinSalary;

        query.hopeMaxSalary = this.hopeMaxSalary;
      }

      let data = {
        pageNo: this.pagingObj.currentPage,

        pageSize: this.pagingObj.pageSize,

        data: query,
      };

      API.recommendEliteByConditions(data).then((res) => {
        if (res.code == 0) {
          this.list = res.data.list;

          this.pagingObj.totalDevice = res.data.total;
        }
      });
    },

    // 查看精英简历

    viewEliteResume(item) {
      let data = {
        data: {
          userId: item.userId,

          positionId: this.positionId,
        },
      };

      API.viewEliteResume(data).then((res) => {
        this.detail = res.data;
      });
    },

    // 不合适

    addInappropriateElite(item) {
      if (!this.$checkAction()) return;

      let data = {
        data: [
          {
            eliteId: item.userId,

            hopeSalaryMin: item.userJobIntentionList[0].hopeMinSalary,

            hopeSalaryMax: item.userJobIntentionList[0].hopeMaxSalary,
          },
        ],
      };

      API.addInappropriateElite(data).then((res) => {
        if (res.code == 0) {
          this.recommendEliteByConditions();
        }
      });
    },

    collectElite(item) {
      if (!this.$checkAction()) return;

      // 取消收藏

      if (item.collectOrNot) {
        let data = {
          data: {
            ids: [item.collectId],
          },
        };

        API.cancelCollectElite(data).then((res) => {
          if (res.code == 0) {
            this.recommendEliteByConditions();
          }
        });
      } else {
        // 收藏

        let data = {
          data: {
            eliteId: item.userId,

            hopeSalaryMin: item.userJobIntentionList[0].hopeMinSalary,

            hopeSalaryMax: item.userJobIntentionList[0].hopeMaxSalary,

            positionId: this.positionId,
          },
        };

        API.addCollectElite(data).then((res) => {
          if (res.code == 0) {
            this.recommendEliteByConditions();
          }
        });
      }
    },

    // 分页

    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;

      this.recommendEliteByConditions();
    },

    onJb(item) {
      this.dialogVisible = true;

      this.rowObj = item;

      this.resetReportDialog();
    },

    // 举报确认

    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            data: {
              type: 4,

              sourceId: this.$store.getters.getCompany.id,

              sourceCode:
                this.$store.getters.getCompany.code ||
                this.$store.getters.getUser.code ||
                "",

              targetId: this.detail.id,

              sourceName: this.$store.getters.getCompany.name,

              targetName: this.detail.username,

              targetCode: this.detail.code,

              content: this.ruleForm.textarea,

              attachmentId: localStorage.getItem("docId"),

              attachmentName: localStorage.getItem("attachmentName"),
            },
          };

          API.report(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功！");

              this.dialogVisible = false;

              this.resetReportDialog();
            }
          });
        } else {
          console.log("error submit!!");

          return false;
        }
      });
    },

    getFileList(fileList) {
      console.log(fileList);
    },

    // 清空举报弹窗状态（textarea + 上传附件）

    resetReportDialog() {
      this.ruleForm.textarea = "";

      try {
        this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      } catch (e) {}

      localStorage.removeItem("docId");

      localStorage.removeItem("docName");

      localStorage.removeItem("TXurl");

      localStorage.removeItem("attachmentName");

      this.uploadKey = Date.now();
    },
  },
};
</script>

<style lang="less" scoped>
.firm-body {
  .EliteRecommendation {
    width: 1200px;

    margin-top: 20px;

    min-height: 700px;

    .box-top {
      padding: 20px 30px;

      height: 140px;

      background: #ffffff;

      border-radius: 15px;

      position: relative;

      box-sizing: border-box;

      box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);

      .left-box {
        height: 100%;

        display: flex;

        flex-direction: column;

        justify-content: space-between;
      }

      .top-left {
        display: flex;

        cursor: pointer;

        .text1 {
          font-size: 12px;

          color: #333300;

          font-weight: 400;
        }

        .text2 {
          font-size: 12px;

          color: #333300;

          font-weight: 400;

          margin: 0 14px;
        }

        .text2-active {
          font-size: 12px;

          color: #409eff ;

          margin: 0 14px;

          font-weight: 400;
        }
      }

      .top-right {
        width: 330px;

        font-size: 12px;
      }
    }

    .box-bottom {
      font-size: 12px;

      .title {
        width: 100%;

        display: flex;

        align-items: center;

        justify-content: space-between;

        color: #333;

        font-size: 12px;

        .left {
          width: 60%;

          .left-img {
            width: 60px;

            height: 60px;

            /* 关键：让伪元素相对于这个容器定位 */

            position: relative;

            overflow: hidden;
          }

          .left-img img {
            width: 100%;

            height: 100%;

            object-fit: cover; /* 保持图片比例 */
          }

          /* 伪元素作为蒙层 */

          .left-img-Mask {
            content: "";

            position: absolute;

            top: 0;

            left: 0;

            width: 100%;

            height: 100%;

            /* 模糊效果，数值越大越模糊 */

            backdrop-filter: blur(5px);

            /* 可选：添加半透明背景增强效果 */

            background-color: rgba(255, 255, 255, 0.2);

            z-index: 1; /* 确保蒙层在图片上方 */
          }

          // img {

          //   width: 100%;

          //   height: 100%;

          // }

          .left-text {
            width: 600px;

            margin-left: 20px;

            display: flex;

            flex-direction: column;

            align-content: center;

            div {
              height: 30px;

              // border: 1px solid gold;

              span {
                display: inline-block;

                max-width: 300px;

                margin-right: 20px;

                white-space: nowrap;

                line-height: 20px;

                white-space: nowrap;

                overflow: hidden;

                text-overflow: ellipsis;
              }
            }
          }
        }

        .center {
          width: 15%;

          display: flex;

          height: 30px;

          // flex-direction: column;

          // border: 1px solid gold;

          img {
            width: 27px;

            height: 27px;

            margin: 0 10px;
          }
        }

        .right {
          width: 25%;

          display: flex;

          .right-button {
            width: 90px;

            box-sizing: border-box;

            margin: 0 10px;

            height: 40px;

            line-height: 40px;

            padding: 0 5px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 5px;

            background-color: #409eff ;

            text-align: center;

            color: #fff;

            font-size: 12px;
          }
        }
      }

      .text-content {
        margin: 0 auto;

        background: #f8f8f8;

        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);

        border-radius: 0px 0px 20px 20px;

        padding: 20px;

        position: relative;

        box-sizing: border-box;

        .no-resume-box {
          display: flex;

          flex-direction: column;

          align-items: center;

          justify-content: center;

          padding: 60px 0;
        }

        .no-resume-text {
          margin-top: 12px;

          font-size: 14px;

          color: #999;
        }

        .right-top {
          position: absolute;

          right: 50px;

          top: 20px;

          cursor: pointer;

          display: flex;

          align-items: center;

          font-size: 16px;

          img {
            width: 26px;

            margin-right: 10px;
          }
        }
      }

      .box-content {
        margin-top: 30px;

        .title {
          font-size: 14px;

          margin: 20px 0;

          font-weight: 500;

          color: #333;

          font-family: PingFangSC-Medium;
        }

        .flex-box2 {
          margin: 20px 0;

          .jn-item {
            display: inline-block;

            background-color: #eee;

            margin: 0 10px;

            color: #333;

            padding: 5px;

            border-radius: 5px;
          }
        }
      }
    }
  }
}

/deep/ .el-collapse-item__header {
  height: 90px;

  background: #ffffff;

  box-shadow: 0px 3px 5px 0px rgba(125, 125, 125, 0.5);

  border-radius: 15px;

  padding: 20px 30px;

  margin: 20px 0;

  box-sizing: border-box;
}

/deep/ .el-collapse-item__arrow {
  display: none;
}

/deep/.el-collapse-item__wrap {
  overflow: hidden;

  border-radius: 0 0 20px 20px;

  width: 98%;

  margin: 0 auto;

  margin-top: -19px;
}

/deep/.el-collapse-item__content {
  padding-bottom: 0;
}

/deep/.elite-contact-popover {
  padding: 10px 12px;
}

.contact-popover-content {
  display: flex;

  flex-direction: column;

  align-items: center;
}

.contact-popover-text {
  font-size: 12px;

  color: #333;

  margin-bottom: 8px;

  line-height: 18px;
}

/deep/ .contact-popover-btn.el-button--mini {
  padding: 5px 10px;

  font-size: 12px;

  line-height: 1;
}

// 分页

.paging-box {
  width: 100%;

  height: 22px;

  margin-top: 20px;

  margin-bottom: 20px;

  display: flex;

  justify-content: flex-end;

  .paging {
    width: 90%;

    height: 100%;

    display: flex;

    justify-content: flex-end;
  }
}
</style>

